import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import FixedPriceList from '../../../components/List/FixedPrice/FixedPriceList'
import { FixedPriceOverviewDto } from '../../../config/registrationConfig'
import { RegistrationListProps } from '../../../components/List/Registration/RegistrationList'
import useEntity from '../../../hooks/useEntity'
import { useTranslation } from 'react-i18next'
import { Spinner, SpinnerSize } from '@fluentui/react'

export default function FixedPriceOverview(props: RegistrationListProps<FixedPriceOverviewDto>): ReactElement {
    const { t: translate } = useTranslation()

    const [lazyItems, , resetLazyItems] = useEntity<FixedPriceOverviewDto[]>(
        () => ({ url: `/file/${props.listProps.file.id}/fixed-price` }),
        props.items === null ? false : null,
    )
    const isItemsLoaded = useMemo(() => props.items !== null || lazyItems.loaded, [props.items, lazyItems])

    const lazyProps: RegistrationListProps<FixedPriceOverviewDto> = useMemo(
        () => ({ ...props, items: lazyItems?.data, reset: resetLazyItems }),
        [isItemsLoaded],
    )

    if (!isItemsLoaded) {
        return <Spinner label={translate('base.loading')} size={SpinnerSize.small} labelPosition="right" />
    }

    if (props.items === null) {
        return <FixedPriceList {...lazyProps} />
    }

    return <FixedPriceList {...props} />
}
